import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import importBannerImage from 'modules/employees/components/ImporterBanner/public/importer-banner-2.jpg'

const BANNER_CLOSED_KEY = 'importer_banner_closed'

const ImporterBanner = ({ clickHandler }: { clickHandler: () => void }) => {
  const [isVisible, setIsVisible] = React.useState(() => {
    return !localStorage.getItem(BANNER_CLOSED_KEY)
  })

  const handleClose = () => {
    setIsVisible(false)
    localStorage.setItem(BANNER_CLOSED_KEY, 'true')
  }

  if (!isVisible) return null

  return (
    <Box>
      <Box
        flexDirection="row"
        width="full"
        gap="s16"
        alignItems="center"
        justifyContent="spaceBetween"
        borderRadius={{ all: 'abs016' }}
        overflowX="hidden"
        overflowY="hidden"
        border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
      >
        <Box width="s360" border={{ right: { width: 's1', style: 'solid', color: 'grey400' } }}>
          <img alt="Importer banner" src={importBannerImage} />
        </Box>
        <Box flexGrow flexDirection="row" paddingX="s16" width="full" justifyContent="spaceBetween">
          <Box gap="s16">
            <Text size="300" weight="semibold" color="grey1000">
              {i18n.t('employees.importer_banner.title')}
            </Text>
            <Text color="grey800" size="200">
              {i18n.t('employees.importer_banner.description')}
            </Text>
            <Button type="secondary" iconName="upload" onClick={() => clickHandler()}>
              {i18n.t('employees.importer_banner.button')}
            </Button>
          </Box>
          <Box cursor="pointer" onClick={handleClose}>
            <Icon.Medium icon="cross" color="grey800" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ImporterBanner
